<template>
  <v-card outlined class="notes-card elevation-0">
    <v-card-title class="headline primary white--text d-flex justify-space-between align-center">
      <div class="d-flex align-center">
        <v-icon left color="white">mdi-note-text</v-icon>
        Nhắc nhở cho cả lớp
      </div>
    </v-card-title>
    <v-card-text class="pa-4">
      <v-textarea
        v-model="notes" 
        outlined
        label="Nhập nhắc nhở cho cả lớp"
        rows="4"
        auto-grow
        background-color="grey lighten-4"
        :hide-details="true"
        class="mt-2"
        @input="debouncedSaveNotes"
      ></v-textarea>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import debounce from 'lodash-es/debounce'

export default {
  name: 'NotesForEvaluate',
  props: {
    currentEvaluation: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      notes: '',
    }
  },
  computed: {
    ...mapGetters('evaluate', ['isLoading']),
    evaluateId() {
      return this.currentEvaluation ? this.currentEvaluation.id : null
    },
  },
  created() {
    this.debouncedSaveNotes = debounce(this.saveNotes, 500)
  },
  methods: {
    ...mapActions('evaluate', ['updateEvaluate']),
    async saveNotes() {
      if (!this.evaluateId) return
      try {
        await this.updateEvaluate({
          id: this.evaluateId,
          evaluateData: { notes: this.notes },
        })
        this.$emit('notes-saved', this.notes)
      } catch (error) {
        console.error('Error saving notes:', error)
      }
    },
    loadNotes() {
      if (this.currentEvaluation && this.currentEvaluation.notes) {
        this.notes = this.currentEvaluation.notes
      } else this.notes = ''
    },
  },
  watch: {
    currentEvaluation: {
      handler: 'loadNotes',
      immediate: true,
    },
  },
}
</script>

<style scoped>
.notes-card {
  margin-bottom: 20px;
  border-radius: 8px;
}
</style>
